<template>
    <div ref="content">
        <top-bar class="shadow" />

        <div class="d-flex">
            <b-collapse v-if="sideBar.show" v-model="sideBar.toggle" id="sidebar-collapse" class="position-relative shadow-right">
                <side-bar />
            </b-collapse>

            <div :class="{'p-3 content-wrapper': true, 'overflow-hidden': contentOverflow}">
                <div class="d-sm-flex align-items-center justify-content-between mb-3" v-if="title != ''">
                    <h1 class="h3 mb-0 text-gray-800">{{ title }}</h1>
                    <slot
                        name="headerLayout"
                        @hide-side-bar="showSideBar = false"
                        @show-side-bar="showSideBar = true"
                    />
                </div>

                <slot />

            </div>

            <ScrollToTop />
        </div>
        <footer-dashboard />
    </div>
</template>

<script>
    import ScrollToTop from "@/components/ScrollToTop";
    import SideBar from '@/components/SideBar'
    import TopBar from '@/components/TopBar'
    import FooterDashboard from '@/components/FooterDashboard'
    import Loading from '@/components/Loading'
    export default {
        name: "LayoutDefault",
        components: {
          ScrollToTop,
            SideBar,
            TopBar,
            FooterDashboard,
            Loading
        },
        props: {
            showSideBar:{
                type: Boolean,
                default: true
            },
            title:{
                type: String,
                default: ''
            },
            contentOverflow: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                sideBar: {
                    show: true,
                    toggle: false
                },
            }
        },
        mounted() {
            if (this.$refs.content.clientWidth >= 990) this.sideBar.toggle = true
            if (!this.showSideBar) this.sideBar.toggle = false
        }
    }
</script>

<style lang="scss" scoped>
    .content-wrapper{
        flex: 3;
        background-color: #f8f9fc;
    }
    .bg-transparent {
        background-color: transparent !important;
    }
    .bg-yellow-gradient {
        background-color: #f9b112;
        background-image: linear-gradient(135deg, #f9b112 0%, rgba(255, 255, 255, 0.8) 100%);
    }
    .shadow-right {
        box-shadow: 0.15rem 0 1.75rem 0 rgba(31, 45, 65, 0.15);
    }
</style>
